import React, { useEffect } from 'react';
import { Banner } from '@lux/banner';
import { Translate } from '@pegasus/translation';
import { ComplementaryColor } from '@lux/tokens';
import { Voucher } from '@lux/graphics';
import { getEmailProvider } from './helpers';
const noop = () => { };
export const Notification = ({ email, hideNotification, onVisible = noop, onLinkClick = noop, onHide = noop, }) => {
    useEffect(() => {
        onVisible();
    }, []);
    const emailProvider = getEmailProvider(email);
    const showLink = !!emailProvider;
    const linkProps = !showLink
        ? {}
        : {
            linkText: React.createElement(Translate, { message: "checkMyEmailButton" }),
            onLinkClick: () => {
                onLinkClick();
                window.open(`http://www.${emailProvider}`, '_blank');
            },
        };
    const onCloseBanner = () => {
        onHide();
        hideNotification();
    };
    return (
    // @ts-ignore @TODO remove after patching lux
    React.createElement(Banner, { title: React.createElement(Translate, { message: "checkMyEmailHeading" }), text: React.createElement(Translate, { message: "checkMyEmailBody", params: { email } }), onCloseBanner: onCloseBanner, 
        // @ts-ignore
        color: ComplementaryColor.cool30, 
        // @ts-ignore
        icon: React.createElement(Voucher, { bgColor: ComplementaryColor.cool20 }), ...linkProps }));
};
//# sourceMappingURL=component.js.map